import { useMemo } from "react";
import React from "react";
import { WarningFilled } from "@ant-design/icons";
import { Tooltip } from "antd";
import moment from "moment";
import { dateToStandardFormat } from "@/utils/dateFormatter";
import { LoadTimeSlot, LoadTimeSlotMap } from "@/utils/enum";

const ETAWindow = ({ etaDate, etaTimeSlotIndex, style }) => {
  const validTimeSlot = useMemo(
    () =>
      etaTimeSlotIndex !== undefined &&
      etaTimeSlotIndex !== null &&
      etaTimeSlotIndex >= LoadTimeSlot.EighthAmToTwelvePm &&
      etaTimeSlotIndex <= LoadTimeSlot.FourPmToEighthPm,
    [etaTimeSlotIndex],
  );

  const content = useMemo(() => {
    if (!etaDate || !validTimeSlot) {
      return null;
    }

    const etaTimeSlotString = LoadTimeSlotMap[etaTimeSlotIndex] || "";
    const etaDateMoment = moment.utc(etaDate);
    const formattedDate = dateToStandardFormat(etaDateMoment);

    if (etaTimeSlotString && formattedDate) {
      return `${formattedDate}, ${etaTimeSlotString}`;
    }
    if (etaTimeSlotString) {
      return etaTimeSlotString;
    }

    return formattedDate;
  }, [etaDate, etaTimeSlotIndex, validTimeSlot]);

  const invalidETAContent = useMemo(() => {
    if (!etaDate) {
      return "Pending";
    }

    const etaWindowStartDate = moment.utc(etaDate).locale("en").local();
    const etaWindowEndDate = moment.utc(etaDate).locale("en").local().add(4, "hours");

    const isSameDayPickup = etaWindowStartDate.isSame(etaWindowEndDate, "day");

    const etaStartFormatted = dateToStandardFormat(etaWindowStartDate, { showTime: true });
    const etaEndFormatted = dateToStandardFormat(etaWindowEndDate, { showTime: true, timeOnly: isSameDayPickup });

    return `${etaStartFormatted - etaEndFormatted}`;
  }, [etaDate]);

  if (!validTimeSlot) {
    // If this is old or bad data, it may not have an etaTimeSlotIndex, render time based on the dateTime
    return (
      <span style={style}>
        {invalidETAContent}
        {etaDate && (
          <Tooltip color="#fff" title="This ETA may be off due to timezone differences.">
            <WarningFilled style={{ color: "#faad14", marginLeft: 8 }} />
          </Tooltip>
        )}
      </span>
    );
  }

  if (!etaDate) {
    return <span style={{ ...style }}>Pending</span>;
  }

  return <span style={{ ...style }}>{`${content}`}</span>;
};

export default ETAWindow;
